// extracted by mini-css-extract-plugin
export var centerText = "_em-8";
export var container = "_em-0";
export var doughnutContainer = "_em-7";
export var legend = "_em-a";
export var legendItemColorDisplay = "_em-b";
export var legendItemLabel = "_em-d";
export var legendItemValue = "_em-c";
export var lg = "_em-5";
export var maxWidth = "_em-9";
export var md = "_em-4";
export var responsive = "_em-6";
export var sm = "_em-3";
export var xs = "_em-2";
export var xxs = "_em-1";